import { useId } from 'react';
import { Form } from 'react-bootstrap';

interface EditBooleanProps {
  readonly label: string;
  readonly value: boolean;
  readonly onChange: (value: boolean) => void;
  readonly helpText?: string;
}

/**
 * Checkbox wrapper. No `mandatory` — a checkbox is always either
 * checked or unchecked. Optional `helpText` renders a Bootstrap
 * `Form.Text` underneath for inline guidance. `id` is auto-generated
 * via `useId()` so the label-for/input-id binding is unique without
 * the caller having to manage it.
 */
export const EditBoolean = ({ label, value, onChange, helpText }: EditBooleanProps) => {
  const id = useId();
  return (
    <>
      <Form.Check type="checkbox" id={id} label={label} checked={value} onChange={(e) => onChange(e.target.checked)} />
      {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
    </>
  );
};
